import {h, Fragment} from "preact"
import { useAppStateSelector, useSort, pick } from "@nosto/preact"
import { useEffect, useRef, useState } from "preact/hooks"
import { sortOptions } from "../config"

import CustomDropdown from "./CustomDropdown"
import GridLayoutToggles from "./GridLayoutToggles"
import SelectedFilters from "./SelectedFilters"
import Sidebar from "./Sidebar"

export default function Toolbar() {
    const { query, response, pageType } = useAppStateSelector(state =>
        pick(state, "query", "response", "pageType")
    )
    const { activeSort, setSort } = useSort(sortOptions)
    const [ sidebarOpen, setSidebarOpen ] = useState(false);
    const sidebarRef = useRef(null);

    useEffect(() => {
        document.body.style.overflow = (sidebarOpen && window.innerWidth < 990) ? "hidden" : "";
        return () => document.body.style.overflow = "";
    }, [ sidebarOpen ])

    useEffect(() => {
        if(window.innerWidth < 990 || !sidebarOpen) return;
        const handleClick = (e) => {
            if(!e.target.closest('.ns-sidebar')) {
                setSidebarOpen(false);
            }
        }

        window.document.addEventListener('click', handleClick);
        return () => window.document.removeEventListener('click', handleClick);
    }, [ sidebarOpen ])

    useEffect(() => {
        const handleKeydown = (e) => {
            if(sidebarOpen && e.key === 'Escape') {
                setSidebarOpen(false);
            }
        }
        window.document.addEventListener('keydown', handleKeydown);
        return () => window.document.removeEventListener('keydown', handleKeydown);
    }, [ sidebarOpen ])

    const closeSidebar = () => {
        if(sidebarRef.current) {
            // avoid aria errors
            sidebarRef.current.blur();
            sidebarRef.current.querySelectorAll('*').forEach(el => el.blur());
        }
        setSidebarOpen(false);
    }

    const handleSortChange = optionId => {
        setSort(optionId)
    }

    const docCount = response.products?.total ?? 0
    const totalSummary = pageType === "search" ? `"${query.query}" - ${docCount} result(s)` : null;
    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    return (
        <>
            {totalSummary && 
                <div
                    class="ns-page-width ns-results"
                    data-nosto-element="totalResults"
                >
                    {totalSummary}
                </div>
            }

            <div class="ns-toolbar ns-page-width ns-w-100 ns-flex ns-flex-nowrap ns-items-center ns-lg-justify-between">
                <button
                    class="ns-filters-toggle ns-toolbar-btn ns-flex ns-items-center ns-flex-nowrap"
                    type="button"
                    aria-expanded={sidebarOpen}
                    aria-label="Toggle filters"
                    onClick={() => setSidebarOpen(prevSidebarOpen => !prevSidebarOpen)}
                >
                    <span class="ns-toolbar-btn-text">
                        {sidebarOpen ? "Hide" : "Show"} Filters
                    </span>
                    <svg class="ns-lg-hidden" aria-hidden="true" role="presentation" focusable="false" width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.5 0.75L5 6L9.5 0.75" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span class="ns-hidden ns-lg-block ns-plus-minus-icon" aria-hidden="true" role="presentation" focusable="false" />
                </button>

                <CustomDropdown
                    value={activeSort}
                    handleChange={handleSortChange}
                    options={options}
                    label={"sort"}
                    title={"Sort by"}
                />

                <GridLayoutToggles />
            </div>

            <Sidebar 
                sidebarOpen={sidebarOpen}
                closeSidebar={closeSidebar}
                sidebarRef={sidebarRef}
            />
        </>
    )
}
